export const TIMEOUT_SEC = 5;
export const API_URL_POSTS =
  "https://geulmadi-default-rtdb.firebaseio.com/posts";
export const API_URL_LIKES =
  "https://geulmadi-default-rtdb.firebaseio.com/likes";
